// extracted by mini-css-extract-plugin
export default {"root":"UANsmV","link":"odPa7O","text":"rzI5_V","logo":"BIbtE1"};